import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deprecation } from '@pixi/utils';
import { ExtensionType, extensions } from '@pixi/extensions';
var PluginSystem = /*#__PURE__*/function () {
  function PluginSystem(renderer) {
    _classCallCheck(this, PluginSystem);
    this.renderer = renderer;
    this.plugins = {};
    Object.defineProperties(this.plugins, {
      extract: {
        enumerable: false,
        get: function get() {
          deprecation("7.0.0", "renderer.plugins.extract has moved to renderer.extract");
          return renderer.extract;
        }
      },
      prepare: {
        enumerable: false,
        get: function get() {
          deprecation("7.0.0", "renderer.plugins.prepare has moved to renderer.prepare");
          return renderer.prepare;
        }
      },
      interaction: {
        enumerable: false,
        get: function get() {
          deprecation("7.0.0", "renderer.plugins.interaction has been deprecated, use renderer.events");
          return renderer.events;
        }
      }
    });
  }
  _createClass(PluginSystem, [{
    key: "init",
    value: function init(staticMap) {
      for (var o in staticMap) {
        this.plugins[o] = new staticMap[o](this.renderer);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var o in this.plugins) {
        this.plugins[o].destroy();
        this.plugins[o] = null;
      }
    }
  }]);
  return PluginSystem;
}();
PluginSystem.extension = {
  type: [ExtensionType.RendererSystem, ExtensionType.CanvasRendererSystem],
  name: "_plugin"
};
extensions.add(PluginSystem);
export { PluginSystem };